module.exports = __webpack_public_path__ + "img/75682.34ff48df.svg";